import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { colors } from 'design-system';

export const MOBILE_HEIGHT = 140;
export const DESKTOP_HEIGHT = 145;

type VisibilityType = {
  visible: boolean;
};

type VisibleProps = 'visible' | 'hidden' | 'collapse';

export const showVisibleContent = (visible: boolean): VisibleProps =>
  visible ? 'visible' : 'hidden';
export const showDisplayContent = (visible: boolean): string =>
  visible ? 'block' : 'none';

const useDetailsHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    forcedInlineText: {
      display: 'inline',
    },
    spacedText: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    separator: {
      width: 1,
      height: 40,
      backgroundColor: colors.white,
      display: 'inline-block',
    },
    toolbarOffset: {
      minHeight: MOBILE_HEIGHT,
      [theme.breakpoints.up('md')]: {
        minHeight: DESKTOP_HEIGHT,
      },
    },
    whiteText: {
      color: colors.white,
    },
    priceWrapper: {
      display: 'inline-block',
      textAlign: 'center',
      margin: `4px ${theme.spacing(2)}px`,
      marginBottom: 0,
    },
    loadingContainer: {
      position: 'absolute',
      top: '20%',
      left: 0,
      right: 0,
    },
    visibleContent: {
      visibility: ({ visible }: VisibilityType) => showVisibleContent(visible),
    },
    displayContent: {
      display: ({ visible }: VisibilityType) => showDisplayContent(!visible),
    },
    spaceDesktop: {
      marginBottom: 10,
      marginTop: 5,
    },
    spaceMobile: {
      marginBottom: 15,
      marginTop: 10,
    },
  }),
);

export default useDetailsHeaderStyles;
